import { viewports as defaultViewports } from '@folklore/ads';
import { useWindowSize } from '@folklore/hooks';

export default function useAdViewport(viewports = defaultViewports): string | null {
    const { width: windowWidth = 0, height: windowHeight = 0 } = useWindowSize();
    return windowWidth > 0 && windowHeight > 0
        ? Object.keys(viewports)
              .sort(function (a, b) {
                  const [aWidth, aHeight] = defaultViewports[a];
                  const [bWidth, bHeight] = defaultViewports[b];
                  if (aWidth === 0 && aHeight === 0) {
                      return 1;
                  }
                  if (aWidth === bWidth) {
                      return aHeight > bHeight ? -1 : 1;
                  }
                  return aWidth === bWidth ? -1 : 1;
              })
              .find((v) => {
                  const [width, height] = defaultViewports[v];
                  return (
                      (windowWidth >= width || width === 0) &&
                      (windowHeight >= height || height === 0)
                  );
              })
        : null;
}
